import React from 'react'

const ErrorMessage = ({ message }) => (
  <span className="sui-error-message">{message}</span>
)

export default ErrorMessage